import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import Dashboard from '../pages/admin/Dashboard'
import Logs from '../pages/admin/Logs'
import Users from '../pages/admin/users/Users'
import Products from '../pages/admin/products/Products'
import ProductHistory from '../pages/admin/ProductHistory'
import Departments from '../pages/admin/Departments'
import Delegations from '../pages/admin/Delegations'
import ProductStates from '../pages/admin/ProductStates'
import ProductTemplates from '../pages/admin/ProductTemplates'
import Sidebar from '../components/menus/Sidebar'
import BottomNav from '../components/menus/BottomNav'
import { useAuth } from '../components/auth/useAuth'
import CabeceraMovil from '../components/menus/CabeceraMovil'
import { useTranslation } from 'react-i18next'
import Chatbot from '../pages/Chatbot'
import ChatbotLogs from '../pages/admin/ChatbotLogs'

export default function AdminRouter () {
	const {clientauth} = useAuth()
	const { t } = useTranslation()

	return (
		<div className="app-layout">
			<Sidebar/>
			<CabeceraMovil rol={clientauth?.rol ?? ""}/>
			<div className="app-content">
				<div className="app-main">
					<Routes>
						<Route path="/dashboard" element={<Dashboard/>}/>
						<Route path="/users" element={<Users/>}/>
						<Route path="/products" element={<Products/>}/>
						<Route path="/product-history/:id" element={<ProductHistory/>}/>
						<Route path="/departments" element={<Departments/>}/>
						<Route path="/delegations" element={<Delegations/>}/>
						<Route path="/product-states" element={<ProductStates/>}/>
						<Route path="/product-templates" element={<ProductTemplates/>}/>
						<Route path="/logs" element={<Logs/>}/>
						<Route path="/chatbot" element={<Chatbot/>} />
						<Route path="/chatbot-logs" element={<ChatbotLogs/>} />
						<Route path="*" element={<NotFoundPage />}/>
					</Routes>
				</div>
			</div>
			<BottomNav/>
		</div>
	)
}
